import {
    assistantAsking,
    assistantAskingForAction,
    assistantAskingForExample, assistantAskingForGenre, assistantAskingForInstructions, assistantAskingForRequirements,
    assistantAskingForSchema, assistantAskingForSynopsis, systemInstruction, userSaying
} from "../../../../../../../ai/Utils";

export const generateSettingPrompt = (vars: {
    genres: string[],
    synopsis: string,
    customPrompt?: string,
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAskingForInstructions([
        "Проанализируй синопсис.",
        "Сгенерируй описание сеттинга.",
        "Разбей текст на абзацы."
    ]))
    .concat(assistantAskingForRequirements([
        "Сеттинг должен быть подробным",
        "Сеттинг не должен включать сюжет истории",
        "Не применяй форматирование текста. Используй ненумерованные списки, разделенные пустой строкой",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": {"title":string, "description":string}}'))
    .concat(assistantAskingForExample({
        data: {
            title: "Футуристичный киберпанк",
            description: "Гигантские деревья и цветы"
        }
    }))
    .concat(assistantAskingForAction(`Нужно описать сеттинг ${vars.customPrompt}`))


export const extractSettingCategoriesPrompt = (vars: {
    genres: string[],
    synopsis: string,
    setting: string,
    categories: string[],
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Перечисли все возможные категории сеттинга", vars.categories.join('\n')))
    .concat(assistantAskingForInstructions([
        "Проанализируй синопсис.",
        "Проанализируй сеттинг.",
        "Определи какие категории сеттинга могут быть выделены."
    ]))
    .concat(assistantAskingForRequirements([
        "Категории должны быть только из списка возможных категорий",
        "Не нужно добавлять категории, которых нет в списке возможных категорий",
        "Обязательно включи в список категории: [География, Локации, Природа, Эпоха, Персонажи]",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": [string]}'))
    .concat(assistantAskingForExample({
        data: ["География", "Природа", "Политика"]
    }))
    .concat(assistantAskingForAction(`Нужно выделить категории сеттинга.`))